import { NumberishId } from "../model/type";
import NotificationDispatcher from "../core/notification-dispatcher/NotificationDispatcher";
import ApiClient from "../infrastructure/api/ApiClient";

const updateManyAvailabilities = (api: ApiClient, notificationDispatcher: NotificationDispatcher): UpdateManyAvailabilities => (offerId, mediumIds, availabilityIds, fields) => {
    return api.offers_Id_Availabilities.patch(offerId, {
        _command: 'UPDATE',
        availabilityIds,
        mediumIds,
        fields
    })
};
export default updateManyAvailabilities;

export type UpdateManyAvailabilities = (offerId: string, mediumIds: Array<NumberishId>, availabilityIds: Array<NumberishId>, fields: UpdatableFields) => Promise<any>

export interface UpdatableFields {
    readonly priceByAbsoluteValue?: number,
    readonly priceByAddedPercent?: number,
    readonly priceByAddedValue?: number,
    readonly productionPriceByAbsoluteValue?: number,
    readonly productionPriceByAddedPercent?: number,
    readonly productionPriceByAddedValue?: number,
    readonly recommended?: boolean,
}